export default __webpack_public_path__ + "smop-login.8951ea241453bd6622b6fd0a0c585c30.png";